import gql from "graphql-tag";

export const engActivities = gql`
  query ($filter: EngActivityFilter) {
    engActivities(filter: $filter) {
      total
      items {
        id
        type
        name
        customName
        title
        start
        end
        shareCode
        org {
          id
          name
        }
        participant {
          title
        }
      }
    }
  }
`;

const engToolActivityTypes = gql`
  {
    engToolActivityTypes {
      category
      id
      data
    }
  }
`;

const engToolActivities = gql`
  {
    engToolActivities {
      id
      activityType
      activityName
      description
      grades
      goalsTeacher
      goalsGradeAll
      goalsItems {
        title
        items
      }
      goalsStudent
      goalsNone
      parentHelp
    }
  }
`;

const engToolWorkSubmissions = gql`
  {
    engToolWorkSubmissions {
      id
      activityType
      title
      description
      grades
    }
  }
`;

const saveEngToolActivityType = gql`
  mutation saveEngToolActivityType($input: FmDictInput!) {
    saveEngToolActivityType(input: $input) {
      category
      id
      data
    }
  }
`;

const saveEngToolActivity = gql`
  mutation saveEngToolActivity($input: EngToolActivityInput!) {
    saveEngToolActivity(input: $input)
  }
`;

const saveEngToolWorkSubmission = gql`
  mutation saveEngToolWorkSubmission($input: EngToolWorkSubmissionInput!) {
    saveEngToolWorkSubmission(input: $input)
  }
`;

export const engGql = {
  engActivities,
  engToolActivityTypes,
  engToolActivities,
  saveEngToolActivityType,
  saveEngToolActivity,
  engToolWorkSubmissions,
  saveEngToolWorkSubmission,
};
